import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  breakpoints, palette,
}: Theme) => ({
  paper: {
    paddingTop: '3rem',
    paddingBottom: '3rem',
    borderRadius: '0.5rem',
  },
  title: {
    marginBottom: '1.5rem',
    [breakpoints.up('md')]: {
      marginBottom: '2rem',
    },
  },
  content: {
    margin: 0,
  },
  callButton: {
    textDecoration: 'none',
    color: palette.common.white,
  },

  footerButtons: {
    marginTop: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    [breakpoints.up('md')]: {
      marginTop: '2rem',
      flexDirection: 'row',
    },
    '&& button, & a': {
      width: '100%',
      [breakpoints.up('md')]: {
        width: 'fit-content',
      },
    },
  },
}));
